// Venue validation -- iteration 100

import { z } from "zod";

// Standalone venue (not a school). lat/lng optional at create time; admin
// can fill them in later once the gmaps pin is confirmed.
export const createVenueSchema = z.object({
  name: z.string().min(1).max(200),
  slug: z.string().min(1).max(120).regex(/^[a-z0-9-]+$/).optional(),
  location: z.string().max(500).nullable().optional(),
  latitude: z.number().min(-90).max(90).nullable().optional(),
  longitude: z.number().min(-180).max(180).nullable().optional(),
  google_place_id: z.string().max(255).nullable().optional(),
});

export const updateVenueSchema = createVenueSchema.partial();

// EventVenue: polymorphic create. Exactly one of school_id / venue_id
// must be provided. The XOR check also fires at the DB level (CHECK
// constraint) but we reject early here for a friendlier error.
export const createEventVenueSchema = z.object({
  school_id: z.string().cuid().nullable().optional(),
  venue_id: z.string().cuid().nullable().optional(),
  label: z.string().max(120).nullable().optional(),
  is_primary: z.boolean().optional(),
}).refine(
  (v) => (v.school_id != null) !== (v.venue_id != null),
  { message: "Exactly one of school_id or venue_id must be set" },
);

export const updateEventVenueSchema = z.object({
  label: z.string().max(120).nullable().optional(),
  is_primary: z.boolean().optional(),
});

export type CreateVenueInput = z.infer<typeof createVenueSchema>;
export type UpdateVenueInput = z.infer<typeof updateVenueSchema>;
export type CreateEventVenueInput = z.infer<typeof createEventVenueSchema>;
export type UpdateEventVenueInput = z.infer<typeof updateEventVenueSchema>;
